<template>
  <v-app>
    <v-container fluid>
      <v-row no-gutters>
            <v-col cols="12" md="12" class="login-part d-flex align-center justify-center flex-column">
              <div class="login-wrapper pt-16 pt-sm-0">
                    <v-form>
                      <v-container>
                        <v-row class="flex-column">
                          <v-col>
                          <div class="d-flex justify-center" justify="center">
                            <v-img src="@/assets/accountxc-logo.png" contain max-width="250" min-width="100"></v-img>
                          </div>
                          </v-col>
                          <v-form
                            ref="log"
                            v-model="valid"
                            lazy-validation
                          >
                            <v-col>
                              <v-text-field
                                light
                                height="50"
                                id="email"
                                ref="email"
                                v-model="email"
                                :rules="emailRules"
                                single-line
                                label="Email Address"
                                required
                              ></v-text-field>
                              <v-text-field
                                light
                                dense
                                height="50"
                                id="password"
                                ref="password"
                                v-model="password"
                                :rules="passRules"
                                :append-icon="isShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="isShowPassword ? 'text' : 'password'"
                                @click:append="isShowPassword = !isShowPassword"
                                single-line
                                label="Password"
                                required
                              ></v-text-field>
                              <v-select
                                class="mb-4"
                                height="50"
                                :items="companies.map(x => {
                                  return {text: x.companyname, value: x._id};
                                })"
                                v-model="companyid"
                                v-bind:error="errorindex == 0"
                                dense
                                placeholder="Company"
                                persistent-hint
                                single-line hint="Please choose company to login">
                              </v-select>
                            </v-col>
                            <v-col class="d-flex justify-space-between">
                              <v-btn
                                class="text-capitalize"
                                light
                                large
                                block
                                :disabled="password.length === 0 || email.length === 0"
                                color="primary"
                                :loading="isFetching"
                                @click="login">
                                Login
                              </v-btn>
                            </v-col>
                            <v-row>
                            <v-col class="d-flex justify-center" cols="6">
                              <v-btn
                                to="/resetpassword"
                                small
                                text
                                class="text-capitalize primary--text">
                                Reset Password
                              </v-btn>
                            </v-col>
                            <v-col class="d-flex justify-center" cols="6">  
                              <v-btn
                                to="/timetracking"
                                small
                                text
                                class="text-capitalize primary--text">
                                Time Tracking
                              </v-btn>
                            </v-col>
                            </v-row>
                          </v-form>
                        </v-row>
                        <v-row class="ma-0">
                          <v-col align="center">
                            <div style="margin-top: 50px; font: 0.85em sans-serif;">
                            {{ link.text }}
                              
                          </div>
                          </v-col>

                        </v-row>
                      </v-container>
                    </v-form>
              </div>
            </v-col>
      </v-row>
    </v-container>
    <v-snackbar
      v-model="alert"
      color="blue">
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="alert = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Login',
  data() {
    return {
      link: {text: 'AccountXC ©2024 Loi Hein Singapore Pte Ltd', link: 'https://www.accountxc.com/'},
      valid: true,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
        v => v.toLowerCase() === this.email
      ],
      passRules: [
        v => !!v || 'Password is required',
        v => v.length >= 6 || 'Min 6 characters'
      ],
      companyid: null,
      email: '',
      password: '',
      isShowPassword: false,
      haserrors: false,
      errorindex: null,
      alert: false,
      message: '',
      companies: [],
    }
  },
  methods: {
    ...mapActions('Authentication', ['loginUser', 'receiveToken', 'receiveLogin']),
    ...mapActions('Account', ['clearAccounts']),
    ...mapActions('Bill', ['clearBills']),
    ...mapActions('Company', ['getCompaniesByTokenRequest']),
    ...mapActions('Chat', ['clearChats']),
    ...mapActions('PayMethod', ['clearPayMethods']),
    ...mapActions('Region', ['clearRegions']),
    ...mapActions('SalesOrder', ['clearSalesOrders']),
    ...mapActions('Township', ['clearTownships']),
    checkError(){
      if(!this.companyid){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    login(){
      if(!this.checkError()) return;
      this.loginUser({email: this.email, password: this.password, companyid: this.companyid});
    },
    clearAll(){
        this.clearAccounts();
        this.clearBills();
        this.clearChats();
        this.clearPayMethods();
        this.clearRegions();
        this.clearSalesOrders();
        this.clearTownships();
      }
  },
  computed: {
    ...mapState('Authentication', {isFetching: state => state.isFetching, hasAlert: state => state.hasAlert, errorMessage: state => state.errorMessage}),
  },

  watch: {
    errorMessage() {
      this.message = this.errorMessage;
      this.alert = this.hasAlert;

    },
  },
  async created() {
    let token = localStorage.getItem('token');
    if (token) this.receiveToken(token);
    else {if (this.isAuthenticated(localStorage.getItem('token'))) this.receiveLogin()}
    this.companies = await this.getCompaniesByTokenRequest();
  },
  async updated() {
      let isLogout = localStorage.getItem('isLogout');
      if(isLogout=='true') this.clearAll();
  },
}

</script>

<style src="./Login.scss" lang="scss"/>
